import { Loader } from "@progress/kendo-react-indicators";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Tooltip } from "@progress/kendo-react-tooltip";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ListTreatmentObjective from "./list-objective";
import { Goal } from "../../../../dataModel/clientModels";



export interface GoalProps{
    goalData:Goal[]
}

const ListTreatmentGoal = (props:GoalProps) => {


    const [treatmentGoal, setTreatmentGoal] = useState([]);
    const [loading, setLoading] = useState(false);
    const [expandedGoal, setExpandedGoal] = React.useState<any>([]);
    const [isDeleteGoals, setIsDeleteGoals] = useState(false);
    const [selectedGoal, setSelectedGoal] = useState<any>();
    const [isEditGoals, setIsEditGoals] = useState(false);
    const [addObjectiveOpen, setAddObjectiveOpen] = useState(false);

    let counterGoals = 1

    const onActionGoal = React.useCallback(
        (event:any, obj:any) => {
            setExpandedGoal({ ...expandedGoal, [obj.id]: !expandedGoal[obj.id] });
        },
        [expandedGoal]
    );

    const handleCloseDeleteDialouge = () => {
        setIsDeleteGoals(false)
    }

  

    const handleCloseEditTreatment = () => {
        setIsEditGoals(false)

    }

    const handleEditGoals = (obj:any) => {
      
        setIsEditGoals(true)
        setSelectedGoal(obj)
    }

    const handleAddObjective = (id:any) => {
       
        setSelectedGoal({ goalId: id });
        setAddObjectiveOpen(true)

    }

    const handleCloseObjective = () => {
        setAddObjectiveOpen(false)
    }

    if (loading) return <Loader />;

    return (
        <div>
            <h4 className='py-4 mb-0 f-20 address-title'><b>Goals</b></h4>
            {props.goalData?.length > 0 && props.goalData?.map(goalItem =>
                <ExpansionPanel
                    id={goalItem.id + "rand"}
                    title={"Goal #" + counterGoals++ + ": " + goalItem.goalName}
                    tabIndex={0}
                    key={goalItem.id}
                    // expandIcon="k-i-plus  fa fa-plus"
                    // collapseIcon="k-i-minus  fa fa-minus"
                    className="main-goal"
                    expanded={expandedGoal[goalItem.id]}
                    onAction={(event) => onActionGoal(event, goalItem)}>
                    {expandedGoal[goalItem.id] && (
                        <ExpansionPanelContent>
                            <div onKeyDown={(e) => e.stopPropagation()}>

                             
                                <div className="show-upper-event d-flex justify-content-between  py-2 align-items-center"></div>
                                <div className="date-timeshow px-3">

                                    <p className="mb-1"><span className="k-icon k-i-calendar-date orange-text-theme "></span><b>Start Date: </b> {goalItem.startDate === null ? " -/-" : moment(goalItem.startDate).format("M/D/YYYY")}</p>
                                    <p className="mb-1"> <span className="k-icon k-i-calendar-date orange-text-theme "></span> <b>End Date: </b> {goalItem.endDate === null ? " -/-" : moment(goalItem.endDate).format("M/D/YYYY")}</p>
                                    <p className="mb-1"> <span className="k-icon k-i-calendar-date orange-text-theme "></span> <b>Target Date: </b> {goalItem.targetDate === null ? " -/-" : moment(goalItem.targetDate).format("M/D/YYYY")}</p>
                                    <p className="mb-1"> <b>Status: </b> {goalItem.status}</p>
                                    <p className="mt-1"><b>Description: </b> {goalItem.goalDescription} </p>
                                    <p className="mb-1 fw-500"><b>Comments: </b>{goalItem.comments}</p>
                                </div>
                                <h4 className='py-4 mb-0 f-20 address-title'><b>Objectives</b></h4>
                                <ListTreatmentObjective objectiveData={goalItem?.objectives} />
                            </div>
                        </ExpansionPanelContent>
                    )}

                </ExpansionPanel>)
            }

           
        </div>
    )
}

export default ListTreatmentGoal;